import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router'
import type { JSX } from 'react'

import { ReportChatScreen } from './-components/report-chat-screen.tsx'

/**
 * Read the URL's search into the page's state.
 *
 * Read loosely, as `useTableQuery` does, rather than through `validateSearch`.
 * A typed search on one route narrows the search type of every `navigate`
 * call in the app.
 *
 * @param search - The parsed search.
 * @returns The open session, when the URL names one.
 */
export function readReportChatSearch(
  search: Record<string, unknown>
): string | null {
  return typeof search.session === 'string' && search.session !== ''
    ? search.session
    : null
}

export const Route = createFileRoute('/lab/report-chat')({
  component: ReportChatPage
})

function ReportChatPage(): JSX.Element {
  const search: Record<string, unknown> = useSearch({ strict: false })
  const session = readReportChatSearch(search)
  const navigate = useNavigate()

  return (
    <ReportChatScreen
      sessionId={session ?? null}
      onSelectSession={id => {
        void navigate({
          to: '.',
          search: prev => ({
            ...(prev as Record<string, unknown>),
            session: id
          })
        })
      }}
      onNewChat={() => {
        void navigate({
          to: '.',
          search: prev => {
            const { session: _open, ...rest } = prev as Record<string, unknown>

            return rest
          }
        })
      }}
      onOpenDraft={id => {
        void navigate({ to: '/lab/report-draft', search: { id } })
      }}
    />
  )
}
